import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

export const isInFrame = (): boolean => window.parent !== window;

// MSAL 5 renews a token in a hidden frame at the redirect address and waits for this page to post the answer back
// (its "redirect bridge"). A frame that holds no answer has nothing to post, and nothing else to do.
export const answerParentFrame = async (): Promise<void> => {
    try {
        await broadcastResponseToMainFrame();
    } catch {
        // No authorization response in the address: not a frame MSAL opened.
    }
};
